import React, { useEffect, useState }from 'react';

import exampleTxt from '../../util/longnecks.txt';
import getText from '../../util/ReadLongnecks';



import Grid from "@mui/material/Grid";
import Box from '@mui/material/Box';


import { stringify } from 'querystring';

import Button from '@mui/material/Button';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, SxProps, TextField } from '@mui/material';

import { attribute, longNeck, valueMap, TraitMap } from '../../types/Types'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea, CardActions } from '@mui/material';

import FilterBox from './FilterBox';
import { LargeNumberLike } from 'crypto';

function manageAttributes (attributes?: attribute[]) {

  if (attributes) {
    return JSON.stringify(attributes);
  }
  else {
    return null;
  }
}

const LongneckCardStyle: SxProps = {
    maxWidth: "128px",
    // height: "128px",
}

const ResponsiveGridBoxStyle: SxProps = {
    display: 'flex',
    // flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    // flexGrow: 1
    // height: "128px",
}


function MultiActionAreaCard(Longneck: longNeck) {
  return (
    <Card sx={LongneckCardStyle}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="128px"
        //   width="16px"
          image={Longneck?.image}
          alt={Longneck?.id.toString()}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            Longneck {Longneck.id.toString()}
          </Typography>
          {/* <Typography variant="body2" color="text.secondary">
            Lizards are a widespread group of squamate reptiles, with over 6,000
            species, ranging across all continents except Antarctica
          </Typography> */}
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Button size="small" color="primary">
          More
        </Button>
      </CardActions>
    </Card>
  );
}

const pageSize = 12;
// 0 -9
// 10 - 19
// 20 - 29

function handlePaginate(page: number, index: number, Longneck: longNeck, LongneckLength: number) {
    if (LongneckLength == 1) {
        return <Grid sx={ResponsiveGridBoxStyle} item xs={12} sm={12} md={12} key={index}>
                    {MultiActionAreaCard(Longneck)}
                </Grid> 
    } else if (page * pageSize <= index && page * pageSize + pageSize > index) {
        return <Grid sx={ResponsiveGridBoxStyle} item xs={2} sm={4} md={3} key={index}>
                    {MultiActionAreaCard(Longneck)}
                </Grid> 
    } else {
        return <></>
    }


    // if (page * pageSize <= index && page * pageSize + pageSize > index) {
    //     return <Grid sx={ResponsiveGridBoxStyle} item xs={2} sm={4} md={3} key={index}>
    //                 {MultiActionAreaCard(Longneck)}
    //             </Grid> 
    // } else if (LongneckLength == 1) {
    //     return <Grid sx={ResponsiveGridBoxStyle} item xs={12} sm={12} md={12} key={index}>
    //                 {MultiActionAreaCard(Longneck)}
    //             </Grid> 
    // } else {
    //     return <></>
    // }
}


function ResponsiveGrid(LongneckArray: longNeck[], page: number, setPage: React.Dispatch<React.SetStateAction<number>>) {
  return (
    <Box sx={{ flexGrow: 1 }}>
      {/* <Grid container sx={{minWidth: '200px'}} spacing={{ xs: 2, md: 3 }} columns={{ xs: 2, sm: 8, md: 12 }}> */}
      <Grid container sx={{}} spacing={{ xs: 2, md: 3 }} columns={{ xs: 2, sm: 8, md: 12 }}>
        {LongneckArray.map((Longneck, index) => 
           handlePaginate(page, index, Longneck, LongneckArray.length)
        )}
      </Grid>
    </Box>
  );
}

const ControlsBoxStyles: SxProps = {
    display: 'flex',
    flexDirection: 'column',
    // width: 
}

const FormBoxStyles: SxProps = {
    backgroundColor: 'white',
    width: '100px',
    marginTop: '10px',
    marginLeft: '10px'
}


const GridBoxStyles: SxProps = {
    display: 'flex',
    flexDirection: 'Row',
    // width: '400px',
}

function checkAttributes(attributes: attribute[], FilterBoxMap: Map<string, string>) {
    // for (let trait of FilterBoxMap.keys()) {
    //     if (attributes.keys())
    // }

    for (let TraitType of FilterBoxMap.keys()) {
        let TraitValue = FilterBoxMap.get(TraitType);
        let found = false;
        attributes.forEach((attribute) => {
            if (attribute.trait_type === TraitType) {
                if (attribute.value === TraitValue) {
                    found = true;
                }
            } else if (TraitValue === "GRAIL") {
                // Grail
                found = true;
            } else if (TraitValue === "") {
                found = true;
            }
        })
        if (!found) {
            return false
        }
    }
    return true
}

const checkAllAttributes = (Longnecks: longNeck[], FilterBoxMap: Map<string, string>) => {



    let TempLongnecks = Longnecks;

    // console.log(Longnecks[0]);
    return TempLongnecks = TempLongnecks.filter(longneck => checkAttributes(longneck.attributes, FilterBoxMap))
}


function LongneckGrid() {
    const [page, setPage] = useState<number>(0);


    const [finalLongNeckArray, setFinal] = useState<longNeck[]>([]);
    const [traitMap, setTraitMap] = useState<TraitMap>(new Map<string, string[]>());

    const [originalLongnecks, setOriginal] = useState<longNeck[]>([]);



    // for (let trait of traitMap.keys()) {
    //     console.log(trait);
    //     filterBoxMap.set(trait, "");
    // }

    const [FilterBoxMap, setFilterBoxMap] = useState<Map<string, string>>(new Map<string, string>());


    useEffect(() => {
      getText(setFinal, setTraitMap, setFilterBoxMap, FilterBoxMap, setOriginal).then(() => {   
          console.log(traitMap);
      }
      );
    //   console.log(traitMap);
    }, [])

    useEffect(() => {
        console.log(FilterBoxMap);
        const filtered = checkAllAttributes(originalLongnecks, FilterBoxMap);
        setFinal(filtered);
    }, [FilterBoxMap])

    const finalLongneckArrayLength = Math.ceil(finalLongNeckArray.length / pageSize);

    return (
        <Box sx={GridBoxStyles}>
            {FilterBox(traitMap, FilterBoxMap, setFilterBoxMap, setPage, finalLongneckArrayLength)}
            {ResponsiveGrid(finalLongNeckArray, page, setPage)}
        </Box>
    );

    // return (
    //   <TableContainer sx={{ maxWidth: '100%' }} component={Paper}>
    //     <Table aria-label="simple table">
    //       <TableHead>
    //         <TableRow>
    //           <TableCell>ID</TableCell>
    //           <TableCell align="right">name</TableCell>
    //           {/* <TableCell align="right">image</TableCell> */}
    //           <TableCell align="right">imageShown</TableCell>
    //           <TableCell align="right">rarity</TableCell>
    //           <TableCell align="right">attributes</TableCell>
    //         </TableRow>
    //       </TableHead>
    //       <TableBody>
    //         {finalLongNeckArray.map((row) => (
    //           <TableRow
    //             key={row?.id}
    //             sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
    //           >
    //             <TableCell component="th" scope="row">
    //               {row?.id}
    //             </TableCell>
    //             <TableCell align="right">{row?.name}</TableCell>
    //             {/* <TableCell align="right">{row?.image}</TableCell> */}
    //             <TableCell align="right">{<img src={row?.image}></img>}</TableCell>
    //             <TableCell align="right">{row?.rarity}</TableCell>
    //             <TableCell align="right">{manageAttributes(row?.attributes)}</TableCell>
    //           </TableRow>
    //         ))}
    //       </TableBody>
    //     </Table>
    //   </TableContainer>
    // );
  }

export default LongneckGrid;
